var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2,13.7L16,10l-5.4-9.2C9.6,0.3,8.6,0,7.4,0C3.3,0,0,3.8,0,8.5c0,1.7,0.4,3.2,1.1,4.5l1.5,2c0,0,9.5,11.6,10.1,12.4     c0,0,0,0,0.1,0.1L9.1,16.6C8.8,15.5,9.2,14.3,10.2,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6,0c-1.4,0-2.8,0.5-3.9,1.3l4.9,8.3c0.7,1.2,0.3,2.7-0.8,3.4l-6.3,3.9l2.7,8.1c3-3.6,8.2-10,8.2-10             c0.6-0.8,1.6-2.4,1.9-3c0.3-0.6,0.7-2.3,0.7-3.5C28,3.8,24.7,0,20.6,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthAlertIcon);
export default __webpack_public_path__ + "static/media/health-alert-icon.bea0f947191af87f2faf97cedafa127e.svg";
export { ForwardRef as ReactComponent };